/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/
// Insert any custom theme js here...


$(async function() {

//Variant images logic
const productOptionsComponent = $("product-interactive-options")[0];
const productSlider = $('.js-product-slider')

  
if (
    productOptionsComponent &&
    $('[data-product-carousel-hidden-images] [data-metafield-variant-image]').length > 0
) {


        const updateThumbCarouselEvents = function(sliderElement){
            const [thumbs] = $(sliderElement.siblings('.js-product-slider-nav')[0]).find('.thumbnail-list');
            Array.from(thumbs.querySelectorAll('.thumbnail')).forEach((el,index) => {
                if(el.hasAttribute('data-metafield-variant-thumbnail-btn')){
                    el.addEventListener('click', (e) => {
                    // const slideNumber = Number(e.target.dataset.slideNumber);
                    const slideNumber = index;
                    sliderElement.slick('slickGoTo', slideNumber);
                    });
                }
            });
        }

        // function addInAllVariantImages(){
        //     if (!$("[data-product-carousel-hidden-images] [data-metafield-variant-image]").length) return;
        //     $(`[data-product-carousel-hidden-images] [data-metafield-variant-image]`).each(function() {
        //         let clone = $($('<div></div>').html($(this).clone())).html();
        //         //SLICK VERSION BUG: to solve need to wrap cloned slide in two divs 
        //         productSlider.slick("slickAdd", `<div><div><div class="slick-item">${clone}</div></div></div>`);
        //     });
        //     $(`[data-product-carousel-hidden-images] [data-metafield-variant-thumbnail]`).each(function() {
        //         let clone = $($('<li></li>').html($(this).clone())).html();
        //         $(".js-product-slider-nav ul").append(`${clone}`);
                
        //     });
        // }

        const addVariantImages = (goToSlide) => {
            if (!$("[data-product-carousel-hidden-images] [data-metafield-variant-image]").length) return;
            const variantId = productOptionsComponent.getCurrentVariant()?.id;
            $(`[data-product-carousel-hidden-images] [data-metafield-variant-image][data-metafield-variant="${variantId}"]`).each(function() {
                let clone = $($('<div></div>').html($(this).clone())).html();
                //SLICK VERSION BUG: to solve need to wrap cloned slide in two divs 
                productSlider.slick("slickAdd", `<div><div><div class="slick-item">${clone}</div></div></div>`);
            });

            $(`[data-product-carousel-hidden-images] [data-metafield-variant-thumbnail][data-metafield-variant="${variantId}"]`).each(function() {
                let clone = $($('<li></li>').html($(this).clone())).html();
                $(".js-product-slider-nav ul").append(`${clone}`);
                
            });
        }

        const setupCarouselImages = function(){
            //Initial setup
            addVariantImages(); 
            $('.js-product-slider-nav [data-metafield-variant-thumbnail]').first().addClass("thumbnail-list__item--active");
            updateThumbCarouselEvents(productSlider);
            // if($(`.js-product-slider [data-metafield-variant-image]`).length > 0){
            //     //remove generic ones
            //     console.log("Variant images detected");
            //     //should remove the generic ones, otherwise
            // }
            //On  page load slide to either first pos or first variant image pos
            let slideIndex = $(`.js-product-slider [data-metafield-variant-image]`).first().closest(".slick-slide").data('slick-index') || 0;
            productSlider.slick('slickGoTo', slideIndex);

            productOptionsComponent.variantsControlElement.addEventListener('variants:change', function(e){
                if (!$("[data-product-carousel-hidden-images] [data-metafield-variant-image]").length) return;
                $(`.js-product-slider [data-metafield-variant-image]`).closest(".slick-slide").remove()
                $(`.js-product-slider-nav [data-metafield-variant]`).remove();

                setTimeout(function(){
                    addVariantImages(true);
                    //update product carousel
                    console.log($('.js-product-slider-nav [data-metafield-variant-thumbnail]'));
                    $('.js-product-slider-nav [data-metafield-variant-thumbnail]').first().addClass("thumbnail-list__item--active");
                    let slideIndex = $(`.js-product-slider [data-metafield-variant-image]`).first().closest(".slick-slide").data('slick-index') || 0;
                    // console.log(slideIndex)
                    productSlider.slick('slickGoTo', slideIndex);
                    let updatedSlideCount = productSlider.find('.slick-slide').length
                    productSlider[0].slick.slideCount = updatedSlideCount;
                    

                    //adjust thumb carousel
                    updateThumbCarouselEvents(productSlider);
                    window.updateThumbCarousel(productSlider);
                });
            })
            
            
        }


        let promiseCustomElementReady = new Promise((resolve, reject) => {
            if (productOptionsComponent.customElementReady) {
                return resolve();
            }
            productOptionsComponent.addEventListener('CustomElement:AfterInit', () => {
                resolve();
            });
        });

        let promiseProductSliderInit = new Promise((resolve, reject) => {
            if (productSlider.hasClass('slick-initialized')) {
                return resolve();
            }
            productSlider.on('init', () => {
                resolve();
            });
        });

        await Promise.all([promiseCustomElementReady, promiseProductSliderInit]);

         
        setupCarouselImages();

    }

});

